import React from 'react';
import styled from 'styled-components';
import { GenericModal } from './Modal';
import { StyledPasswordInput } from './StyledInput';
import { Button } from './Button';
import { Product } from '../model/Products';
import { useApiQuery } from '../utils/apiHooks';
import { ApiRequest } from '../utils/api';
import { OfferingType } from '../utils/offeringType';
import consumerProducts from '../utils/consumerProducts';

const SHOW_RAJATON_TURBO_CAMPAIGN = false;

const Container = styled.div`
	text-align: center;
	.title {
		font-size: 1.5em;
	}
`;

const FormContainer = styled.div`
	margin-bottom: 1.818em;
`;

const InputContainer = styled.div`
	width: 17.045em;
	height: 2.386em;
	margin: auto;
	margin-top: 1.818em;
	display: inline-block;
`;

const LeftAlign = styled.span`
	float: left;
	font-size: 1.2em;
	padding-left: 2rem;
	display: inline-block;
	@media (max-width: 700px) {
		float: none;
		text-align: center;
	}
`;

const RightAlign = styled.span`
	float: right;
	font-size: 1.2em;
	padding-right: 2rem;
	display: inline-block;
	@media (max-width: 700px) {
		float: none;
		text-align: center;
		padding-left: 2rem;
	}
`;

const Description = styled.div`
	font-size: 0.8em;
	display: inline-block;
	padding: 1rem 3rem 1rem 3rem;
	text-align: left;
	@media (max-width: 700px) {
		width: 25em;
		top: 50%;
		left: 15em;
	}
`;

const Message = styled.div`
	display: inline-block;
	padding: 1rem 3rem 1rem 3rem;
	text-align: left;
	@media (max-width: 700px) {
		width: 25em;
		top: 50%;
		left: 15em;
	}
`;

const PaddingBottom = styled.div`
	padding-bottom: 2rem;
`;

const RedText = styled.div`
	color: red;
`;

const modalStyles = {
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: '#bcbcbc',
		width: '100%',
		height: '100%',
		padding: '2.102em 0.909em 0em 1.023em'
	},
	content: {
		height: 'auto',
		minHeight: '0px',
		width: '35em'
	}
};

const CampaignText = styled.div`
	h5 {
		color: #f00;
		font-size: 1.2rem;
	}
	.campaign-price {
		font-weight: bold;
	}
	a {
		color: #f00;
	}
	ol {
		padding-left: 0;
		li {
			ol {
				padding-left: 1rem;
			}
		}
	}
`;

const getSum = (monthlyCostTotal: number, length: number) => {
	return (
		<PaddingBottom>
			{length > 1 && (
				<div>
					<LeftAlign className={'title'}>Kuukausimaksut yhteensä</LeftAlign>
					<RightAlign className={'title'}>{monthlyCostTotal} €/kk</RightAlign>
				</div>
			)}
			<br />
			<React.Fragment>
				<LeftAlign className={'title'}>Toimitusmaksu</LeftAlign>
				<RightAlign className={'title'}>{consumerProducts.getShippingPrice()} €</RightAlign>
			</React.Fragment>
			<br />
		</PaddingBottom>
	);
};

const getPrice = (productPackageTypeValues: any, subscription: any) => {
	const selectedPackage = productPackageTypeValues.filter((selected: any) => selected.orderItemCode === subscription.packageSpecs.value.orderItemCode)[0];
	return (
		<div>
			<LeftAlign>{subscription.subscriptionName.value}</LeftAlign>
			<RightAlign>{selectedPackage.eurPerMonth} €/kk</RightAlign>
		</div>
	);
};

const getDescription = (productPackageTypeValues: Product[], subscriptionType: string, offeringType: OfferingType) => {
	const selectedPackage = productPackageTypeValues.filter((selected: any) => selected.orderItemCode === subscriptionType)[0];
	if (!selectedPackage) {
		return '';
	}
	const hasUnlimitedData = selectedPackage.dataPackage === 'unlimited';
	const hasUnlimitedVoice = selectedPackage.orderItemCode.endsWith('ULV');

	return (
		<Description>
			{selectedPackage.displayName} -liittymä. {selectedPackage.dataSpeedMbs} Mbit/s,
			{!hasUnlimitedData ? ` ${selectedPackage.addToSharedDataGbAmount} Gt dataa` : ' Rajaton data'}.
			{offeringType === OfferingType.CONSUMER4 ? `EU-roaming ${parseInt(selectedPackage.euDataLimitMB) / 1000} Gt.` : ''}
			{!hasUnlimitedVoice ? ` Puhelut ${selectedPackage.eurPerMoi} €/min` : ' Rajattomasti kotimaan puhetta'}
			{` ja tekstiviestit ${selectedPackage.eurPerMoi} €/kpl`}
			{offeringType !== OfferingType.CONSUMER2B ? `, mutta aina yhteensä enintään ${selectedPackage.maxEurMoisPerMonth} €/kk!` : ''}
			{!hasUnlimitedData ? `. Lisädata ${selectedPackage.eurPerOverage.toFixed(2)}€/Gt` : ''}
			{subscriptionType === 'B2C_PACK_FAST' && SHOW_RAJATON_TURBO_CAMPAIGN && (
				<CampaignText>
					<h5>TURBO RAJATTOMAN HINNALLA KOLMEKSI KUUKAUDEKSI!</h5>
					<p className={'campaign-price'}>Saat Moin vanhana asiakkaana RAJATON TURBO -liittymän 3 kuukaudeksi alennettuun hintaan 18 €/kk (norm. 23 €/kk)</p>
					<p>
						Jos et halua jatkaa tarjouksen keston jälkeen (3 kk tilauksesta) normaalihinnalla, (23 €/kk + puhe/SMS yhteensä enintään 4 €/kk), sinun tulee muuttaa liittymätyyppisi johonkin Moin uusista
						vaihtoehdoista ennen tarjousjakson loppua. Tämä tarjous koskee VAIN nykyisiä Moin asiakkaita. Tarjous voimassa 26.1.2020 asti.
					</p>
					{/* <span>Lue tästä yksityiskohtaiset tarjousehdot</span>
					<div className="campaign-terms" id="campaign-terms">
						<div className="close-campaign-terms" role="button">
						<span>sulje</span>
						<svg-icon data-icon="small--x--black" class="close-campaign-term--icon ng-isolate-scope">
							<span className="svg-small--x--black svg-small--x--black-dims"></span></svg-icon>
						</div>
						<ol>
						<li>Tarjous koskee niitä Moin asiakkaita, jotka vaihtavat vanhan hinnaston (ennen 13.6.2019) mukaisen
							liittymänsä Rajaton Turbo-liittymään Mun Moin
							<a target="_blank" href="https://www.moi.fi/hinnasto">verkkosivuilla</a>
						</li>
						<li>Rajaton Turbo-liittymän ominaisuudet:
							<ol>
							<li>Kuukausimaksu 23€/kk</li>
							<li>Rajaton datasiirto kotimaassa maksiminopeudella 300Mb/s</li>
							<li>Puhelut ja tekstiviestit 0,055€/min/kpl, yhteensä enintään +4€/kk Liittymä sisältää lisäksi 10Gt/kk
								tiedonsiirtoa EU-maissa
							</li>
							<li>Tarjous antaa 5€ alennuksen Rajaton Turbo-liittymän kuukausimaksusta (normaalihinta 23€/kk) 3
								kuukauden ajan
							</li>
							</ol>
						</li>
						<li>Tarjouksen voimaantulo ja päättyminen
							<ol>
							<li>Tarjous on voimassa 26.01.2020 asti</li>
							<li>Alennus alkaa tilaushetkestä ja on voimassa siitä eteenpäin 3 kuukautta</li>
							<li>Mikäli alennus tulee voimaan kesken laskutuskauden, vajaan laskutuskauden alennus annetaan
								tilaushetkestä eteenpäin laskutuskauden jäljellä olevien päivien suhteessa. Alennuksen päättyessä
								kesken laskutuskauden, alennus annetaan laskutuskaudelta tarjouksen voimassaolopäivien suhteessa (pro
								rata).
							</li>
							<li>Asiakas voi milloin tahansa kesken tarjouskauden vaihtaa liittymätyyppiä palveluehtojen mukaisesti.
								Tällöin alennus lakkautuu ja asiakkaalta veloitetaan hinnaston mukainen maksu valitun liittymätyypin
								mukaan.
							</li>
							</ol>
						</li>
						</ol>
						<p>Huoh. kapulakieltä, valaistaan esimerkillä. Jos tilaat Turbo-liittymän puolivälissä laskutuskautta saat
						ensimmäiseltä laskutuskaudelta 2,5€ alennusta, kahdelta seuraavalta täydeltä kaudelta 5€/kausi ja
						viimeiseltä puolikkaalta 2,5€. Yhteensä alennusta kertyy aina 15€ kolmen kuukauden tarjousjaksolta.</p>
						<p>Mikäli asiakkaalla on tilillään useita liittymiä, kaikki tilin liittymät on siirrettävä uuden,
						12.6.2019-alkaen voimassa olevan hinnaston mukaisiin liittymiin. Tarjousta voi käyttää kaikkiin tilin
						liittymiin tai vain osaan. Mikäli asiakas haluaa vaihtaa liittymätyyppiä tarjousajan jälkeen, uusi liittymä
						on valittava voimassa olevan hinnaston mukaisista<a target="_blank" href="https://www.moi.fi/hinnasto">liittymistä</a></p>
					</div> */}
				</CampaignText>
			)}
		</Description>
	);
};

interface SubscriptionOrderModalProps {
	isOpen: boolean;
	onRequestClose: () => void;
	onConfirm: () => void;
	title: string;
	subscriptions: any[];
	monthlyCostTotal: number;
	offeringType: OfferingType;
}

export const SubscriptionOrderModal: React.FC<SubscriptionOrderModalProps> = (props: SubscriptionOrderModalProps) => {
	const { data: products } = useApiQuery(ApiRequest.getProducts(props.offeringType), { cacheTime: 600000 }); // TODO: products get fetched even though should be cached?

	return (
		<GenericModal isOpen={props.isOpen} onRequestClose={props.onRequestClose} modalStyle={modalStyles}>
			<Container>
				<span className={'title'}>{props.title}</span>
				<FormContainer>
					{products !== undefined &&
						props.subscriptions.map((subscription, key) => (
							<div key={key}>
								{getPrice(products.productPackagePrices, subscription)}
								{getDescription(products.productPackagePrices, subscription.packageSpecs.value.orderItemCode, props.offeringType)}
							</div>
						))}
					{getSum(props.monthlyCostTotal, props.subscriptions.length)}
				</FormContainer>
				<Button onClick={props.onConfirm}>OK</Button>
				<Button className="invisible" onClick={props.onRequestClose}>
					Peruuta
				</Button>
			</Container>
		</GenericModal>
	);
};

interface ConfirmModalProps {
	isOpen: boolean;
	onRequestClose: () => void;
	onConfirm: () => void;
	title: string;
	onPasswordChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	errorMessage?: string;
	message?: string;
	productPackageTypeValues?: Product[];
	selectedSubscriptionType?: string;
	offeringType?: OfferingType;
	password?: string;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = (props: ConfirmModalProps) => {
	return (
		<GenericModal isOpen={props.isOpen} onRequestClose={props.onRequestClose} modalStyle={modalStyles}>
			<Container>
				<span className={'title'}>{props.title}</span>
				<FormContainer>
					{props.message !== undefined && <Message>{props.message}</Message>}
					{props.productPackageTypeValues !== undefined &&
						props.selectedSubscriptionType !== undefined &&
						props.offeringType !== undefined &&
						getDescription(props.productPackageTypeValues, props.selectedSubscriptionType, props.offeringType)}
					{props.password !== undefined && (
						<InputContainer>
							<StyledPasswordInput title={'Salasana'} backgroundColor={'white'} name={'password'} onChange={(e) => props.onPasswordChange!(e)} />
						</InputContainer>
					)}
				</FormContainer>
				{props.errorMessage !== undefined && <RedText>{props.errorMessage}</RedText>}
				<Button onClick={props.onConfirm} disabled={props.password !== undefined && props.password === ''}>
					OK
				</Button>
				<Button className="invisible" onClick={props.onRequestClose}>
					Peruuta
				</Button>
			</Container>
		</GenericModal>
	);
};
